var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 .00024414c-5.52 0-10 4.47999586-10 9.99995586 0 5.52 4.48 10 10 10s10-4.48 10-10c0-5.51996-4.48-9.99995586-10-9.99995586zm0 1.99999586c4.41 0 8 3.59 8 7.99996 0 1.5-.42 2.9-1.14 4.1-1.96-1.6-4.39-2.48-6.96-2.48s-4.88.84-6.82 2.38c-.68-1.18-1.08-2.54-1.08-4 0-4.40996 3.59-7.99996 8-7.99996zm-5.71 13.58996c1.59-1.27 3.56-1.97 5.61-1.97s4.12.73 5.72 2.06c-1.45 1.43-3.43 2.32-5.62 2.32s-4.26-.92-5.71-2.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.9 11.2302c2.43 0 4.4-1.96996 4.4-4.39996s-1.97-4.4-4.4-4.4-4.4 1.97-4.4 4.4 1.97 4.39996 4.4 4.39996zm0-6.79996c1.32 0 2.4 1.08 2.4 2.4s-1.08 2.4-2.4 2.4-2.4-1.08-2.4-2.4 1.08-2.4 2.4-2.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/IconAvatar.08a6ba91827b463104737506653b5ab0.svg";
export { ForwardRef as ReactComponent };